import { signal, type WritableSignal } from '@angular/core';
import type { ISettingsRepository } from '@app/domain/ports';
import { AI_SESSION_SETTINGS } from './ai-session-setting-keys';

export class AiSessionSettingsService {
  readonly relayUrl: WritableSignal<string>;

  constructor(private readonly settings: ISettingsRepository) {
    this.relayUrl = signal(this.settings.get<string>(AI_SESSION_SETTINGS.RELAY_BASE_URL, ''));
  }

  saveRelayUrl(value: string): string {
    const normalized = this.normalizeRelayUrl(value);
    this.settings.set(AI_SESSION_SETTINGS.RELAY_BASE_URL, normalized);
    this.relayUrl.set(normalized);
    return normalized;
  }

  normalizeRelayUrl(value: string): string {
    const url = new URL(value.trim());
    const localhost = url.hostname === 'localhost' || url.hostname === '127.0.0.1' || url.hostname === '[::1]';
    if (url.protocol !== 'https:' && !(localhost && url.protocol === 'http:')) {
      throw new Error('Relay URL must use HTTPS except on localhost');
    }
    url.hash = '';
    url.search = '';
    // Accept the MCP endpoint that AI clients use; Finance talks to the relay base URL.
    url.pathname = url.pathname.replace(/\/mcp\/?$/i, '');
    return url.toString().replace(/\/$/, '');
  }
}
